
import { createAction, props } from '@ngrx/store';
import {
  AddOn,
  Attachment,
  Vendor,
} from 'src/app/shared/models/database-models';
import {
  DOTPReason,
  FormStatus,
  GeneralForm,
  IBudgetAllocForm,
  IItemToRequest,
  MyPurchaseForm,
  TenderDate,
  TenderItemFormI,
  WOCReason,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { WaiverOfCompetition } from '../../shared/models/database-models/SaveMyPurchase.model';
import { DisplayItemNumberToSourcingStatusIdMap } from 'src/app/modules/mypurchase-form/rfs/tag-item-vendor.service';

export const updateGeneralForm = createAction(
  '[Form Page]  UpdateGeneralForm',
  props<{ form: GeneralForm }>()
);

export const addItemtoMyPurchase = createAction(
  '[Form Page] addItemtoMyPurchase',
  props<{ form: IItemToRequest }>()
);

export const addAttachmenttoMyPurchase = createAction(
  '[Form Page] addAttachmenttoMyPurchase',
  props<{ form: Attachment }>()
);

export const addVendorsToMyPurchase = createAction(
  '[Form Page] addVendorsToMyPurchase',
  props<{ vendors: Vendor[] }>()
);

export const updateVendorsToMyPurchase = createAction(
  '[Form Page] updateVendorsToMyPurchase',
  props<{ vendors: Vendor[] }>()
);

export const updateItemForm = createAction(
  '[Form Page] updatePurchaseForm',
  props<{ form: IItemToRequest }>()
);

export const updateItemsSourcingStatus = createAction(
  '[Form Page] updateItemsSourcingStatus',
  props<{
    displayItemNumberToSourcingStatusIdMap: DisplayItemNumberToSourcingStatusIdMap;
    purchaseExecutive: string;
  }>()
);

export const updateBudgetForm = createAction(
  '[Form Page] updateBudgetForm',
  props<{ form: IBudgetAllocForm }>()
);

export const updatePurchaseForm = createAction(
  '[Form Page] updatePurchaseForm',
  props<{ form: MyPurchaseForm }>()
);

export const updateAttachments = createAction(
  '[Form Page] updateAttachments',
  props<{ form: Attachment; isReplace?: boolean }>()
);

export const deleteItemFromMyPurchase = createAction(
  '[Form Page] deleteItemFromMyPurchase',
  props<{ itemId: number }>()
);

export const deleteDraftItemFromMyPurchase = createAction(
  '[Form Page] deleteDraftItemFromMyPurchase',
  props<{ itemId: number }>()
);

export const deleteVendorsFromMyPurchase = createAction(
  '[Form Page] deleteVendorsFromMyPurchase',
  props<{ vendors: Vendor[] }>()
);

export const deleteBudgetFromMyPurchase = createAction(
  '[Form Page] deleteBudgetFromMyPurchase',
  props<{ form: IBudgetAllocForm }>()
);

export const deleteAttachmentsFromMyPurchase = createAction(
  '[Form Page] deleteAttachmentsFromMyPurchase',
  props<{ form: Attachment }>()
);

export const clearStore = createAction('[Form Page] clearStoreFromMyPurchase');

export const updateApprovingOfficer = createAction(
  '[Form Page] updateApprovingOfficer',
  props<{ approvingOfficer: string; itemNo: string; budgetInfo: any }>()
);

export const updateApprovingOfficerRequired = createAction(
  '[Form Page] updateApprovingOfficerRequired',
  props<{ isRequired: boolean }>()
);

export const updateWholeForm = createAction(
  '[Form Page] updateWholeForm',
  props<{ form: MyPurchaseForm }>()
);

export const updateMPNumber = createAction(
  '[Form Page] updateMpNumber',
  props<{ MPNumber: string }>()
);

export const updateFormType = createAction(
  '[Form Page] updateFormType',
  props<{ typeId: number }>()
);

export const updateIsRFSEnabled = createAction(
  '[Form Page] updateisRFSEnabled',
  props<{ isRFSEnabled: boolean }>()
);

export const updateFormStatus = createAction(
  '[Form Page] updateFormStatus',
  props<{ formStatus: FormStatus }>()
);

export const updateTenderItemForm = createAction(
  '[Form Page]  UpdateTenderItemForm',
  props<{ form: TenderItemFormI }>()
);

export const addOptionToPurchase = createAction(
  '[Form Page] addOptionToPurchase',
  props<{ option: AddOn }>()
);

export const updateOptionToPurchase = createAction(
  '[Form Page] updateOptionToPurchase',
  props<{ option: AddOn }>()
);

export const updateTenderDate = createAction(
  '[Form Page] UpdateTenderDate',
  props<{ TenderDate: TenderDate }>()
);

export const deleteAddOnOptionFromMyPurchase = createAction(
  '[Form Page] deleteAddOnOptionFromMyPurchase',
  props<{ itemId: number, actualIdx: number }>()
);

export const updateWOCToMyPurchase = createAction(
  '[Form Page] updateWOCToMyPurchase',
  props<{
    woc: {
      reason: WOCReason;
      fileReferenceNumber: string | null;
      justification: string | null;
      wocId: string | null
    };
  }>()
);

export const updateDOTPToMyPurchase = createAction(
  '[Form Page] updateDOTPToMyPurchase',
  props<{
    dotp: {
      reason: DOTPReason;
      remarks :string | null;
      justification: string | null;
      dotpId: string | null
    };
  }>()
);

export const updateRFQDeadline = createAction(
  '[Form Page] updateRFQDeadline',
  props<{ RFQDeadline: number }>()
);

export const updatePDPCompliance = createAction(
  '[Form Page] updatePDPCompliance',
  props<{ PDPComplianceItemNumbers: string | null }>()
);